import {gql} from "@apollo/client";
import {AccountType} from "graphql/types/AccountType";

export const GET_ACCOUNT_LISTING_FOR_HEADQUARTERS = gql`
    query GetAccountListingForHeadquarters {
        allAccounts: getAccountListingForHeadquarters {
            id
            name
            countryCode
            phone
            email
            status
            role {
                name
            }
            createdAt
            updatedAt
        }
    }
`;

export interface GetAccountListingForHeadquartersResponse {
    allAccounts: AccountType[];
}

